/* ==========================================================================
   SC ANALYTICS — Core Web Vitals, scroll depth, and active time tracking.
   All events go to the GA4 dataLayer. Loaded site-wide from theme.liquid.

   Events fired:
     web_vitals    — one per metric per page load (LCP, CLS, INP, TTFB, FCP)
                     params: web_vital_name, web_vital_value, web_vital_id,
                             web_vital_rating (good | needs-improvement | poor)
     scroll_depth  — at 25 / 50 / 75 / 100 percent
                     params: scroll_percentage, page_path
     active_time   — at 15s / 30s / 60s / 120s / 300s of ACTIVE time
                     (timer pauses while the tab is hidden)
                     params: seconds, page_path

   Note: FID was retired in web-vitals v4. INP is its official Core Web
   Vitals replacement (Google, March 2024), so we track INP instead.
   ========================================================================== */
(function () {
  'use strict';

  /* Ensure gtag exists. Shopify's Google & YouTube channel may load it
     in a sandbox or after our script runs. This is Google's own standard
     initialisation pattern — it pushes to the same dataLayer that GA4
     reads from, so events are picked up regardless of load order. */
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function () { dataLayer.push(arguments); };
  }

  function push(obj) {
    var evt = obj.event;
    var params = {};
    for (var k in obj) { if (k !== 'event') params[k] = obj[k]; }
    window.gtag('event', evt, params);
  }

  var PAGE = window.location.pathname;

  /* ── 1. Scroll depth: 25 / 50 / 75 / 100 ── */
  (function () {
    var marks = [25, 50, 75, 100];
    var fired = {};
    var ticking = false;

    function check() {
      ticking = false;
      var doc = document.documentElement;
      var total = doc.scrollHeight;
      if (!total) return;
      var pct = Math.round(((window.scrollY || doc.scrollTop) + window.innerHeight) / total * 100);
      for (var i = 0; i < marks.length; i++) {
        var m = marks[i];
        if (pct >= m && !fired[m]) {
          fired[m] = true;
          push({ event: 'scroll_depth', scroll_percentage: m, page_path: PAGE });
        }
      }
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(check);
      }
    }, { passive: true });

    /* Short pages where the fold already covers a milestone */
    window.addEventListener('load', check);
  })();

  /* ── 2. Active time: pauses when the tab is hidden ── */
  (function () {
    var REPORT_AT = [15, 30, 60, 120, 300];
    var activeTime = 0;
    var reported = {};
    var interval = null;

    function tick() {
      activeTime++;
      for (var i = 0; i < REPORT_AT.length; i++) {
        var t = REPORT_AT[i];
        if (activeTime === t && !reported[t]) {
          reported[t] = true;
          push({ event: 'active_time', seconds: t, page_path: PAGE });
        }
      }
      if (activeTime >= REPORT_AT[REPORT_AT.length - 1]) stop();
    }
    function start() { if (!interval) interval = setInterval(tick, 1000); }
    function stop() { if (interval) { clearInterval(interval); interval = null; } }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
    if (!document.hidden) start();
  })();

  /* ── 3. Core Web Vitals via the web-vitals library (IIFE build) ── */
  (function () {
    function bind() {
      var wv = window.webVitals;
      if (!wv) return;
      function send(metric) {
        push({
          event: 'web_vitals',
          web_vital_name: metric.name,
          /* CLS is a unitless score around 0.0 to 0.5; multiply so the GA4
             custom metric (integer ms elsewhere) stays comparable. */
          web_vital_value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
          web_vital_id: metric.id,
          web_vital_rating: metric.rating,
          page_path: PAGE
        });
      }
      if (wv.onLCP) wv.onLCP(send);
      if (wv.onCLS) wv.onCLS(send);
      if (wv.onINP) wv.onINP(send);
      if (wv.onTTFB) wv.onTTFB(send);
      if (wv.onFCP) wv.onFCP(send);
    }

    var s = document.createElement('script');
    s.src = 'https://unpkg.com/web-vitals@4/dist/web-vitals.iife.js';
    s.async = true;
    s.onload = bind;
    document.head.appendChild(s);
  })();

})();
